export const HTTP_CONSTANTS: {
  protocol: string;
  baseAddress: string;
} = {
  protocol: "[HTTP_PROTOCOL]",
  baseAddress: "[HTTP_BASE_ADDRESS]",
};
